import { Autocomplete, Box, Checkbox, Dialog, DialogActions, DialogContent, FormControlLabel, FormHelperText, TextField } from "@mui/material";
import Grid from '@mui/material/Grid';
import  { useEffect, useState } from "react";
import {  useRecoilValue } from "recoil";
import { DateTimeHelper, StringDateTimeHelper } from "../../../Component/Model/helpers"
import { toast } from "react-toastify";
import { Note } from "../../../Component/Model/Dto/Note";
import { NoteService } from "../../../Component/Api/Note/NoteService";
import { UserAtom } from "../../../State/user.Atom";
import { FeedbackTable } from "./Feedback/FeedbackTable";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { noteSchema } from "./NoteValidation";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { MDBox } from "../../../Component/Common/Components/MDBox";
import { MDTypography } from "../../../Component/Common/Components/MDTypography";
import { Quill } from "../../../Component/Common/Components/Quill/Quill";
import { SmallLoading } from "../../../Component/Common/Components/Loading/IntermediateLoading";
import { CustomDialogTitle } from "../Custom/CustomDialogTitle";
import LoadingButton from "@mui/lab/LoadingButton";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { UserActivityService } from "../../../Component/Api/UserActivity/UserActivityService";
import { UserActivityActionType } from "../../../Component/Model/Enum/BEE123Enums";
import { ValidatedMobileDatePicker } from "../../../Component/Common/Components/ValidatedMobileDatePicker/ValidatedMobileDatePicker";


interface IProps {
    id?: string;
    userId?: string;
    linkedEntityId?:string;
    scorecardId: string;
    scorecardElement?: number;
    noteCaptureSheet?: number;
    handleCancel: () => void;
    refreshTable: () => void;
    setNoteId: (id: string) => void;
    showNoteModal: boolean;
    closeNoteModal: () => void;
    section?: string;
}

export const NoteModal = (props: IProps) => {

    const user = useRecoilValue(UserAtom);
    const [userList, setUserList] = useState<Note.UserListItem[]>([]);
    const [invalidUserList, setInvalidUserList] = useState<Note.UserListItem[]>([]);
    const [createdDate] = useState<Date>(new Date());
    const [noteId, setNoteId] = useState<string | undefined>(props.id);
    const [userId, setUserId] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [canEdit, setCanEdit] = useState<boolean>(true);

    const descriptionMaxLength = 1000;
    const [remainingNoteCharacters, setRemainingNoteCharacters] = useState(descriptionMaxLength);

    const  { control, reset, handleSubmit, formState: { errors, isSubmitting },setValue, watch} = useForm<Note.Dto>({
        mode: 'all',
        defaultValues: {
            ScorecardId: props.scorecardId,
            CreatedDate: createdDate.toUTCString(),
            UserId: userId,
            EditUserId: userId,
            Username: user.username,
            ScorecardElement: props.scorecardElement,
            NoteCaptureSheet: props.noteCaptureSheet,
            LinkedEntityId: props.linkedEntityId,
            ActionDate: null,
            Status: false
        },
        resolver: yupResolver(noteSchema)
    });
    const invalidUsers = watch('InvalidResponsibleUserList');

    const notesLog = (actionType: number, actionDescription: string) => {
        UserActivityService.createActivityLog({
            section: props.section ?? "",
            actionType: actionType,
            actionDescription: actionDescription,
            scorecardId: props.scorecardId,
            requestUrl: window.location.href
        });
    }
   
    const handleDataSubmit: SubmitHandler<Note.Dto> =  async(note: Note.Dto) => {
        try{
            note.UserId = userId;
            note.EditUserId= userId;
            let result = await NoteService.SaveNote(note);
            if(!noteId){
                notesLog(UserActivityActionType.Create, "Add a new note");
                toast.success("Note added succesfully");
            }else{
                notesLog(UserActivityActionType.Update, "Edit a note");
                toast.success("Note saved succesfully")  
            }
            const savedNoteId = result.data;
            props.setNoteId(savedNoteId);
            setNoteId(savedNoteId);
            setValue("Id", savedNoteId);
            
        }catch (error) {
            console.log(error)
        }
    }

    const handleCancel = () => {
        props.refreshTable();
        props.handleCancel();
    }

    const getNote = async(id: string) => {
        setIsLoading(true);
        try {
            let result = await NoteService.GetNoteById(id);
            setCanEdit(result.data.EditUserId == result.data.UserId)
            reset(result.data);  
            
        } catch (error) {
            console.log(error)
        }finally{
            setIsLoading(false);
        }
    }

    const getResponsiblePersonList = async() => {
        try {
            let result = await NoteService.GetUserList(props.scorecardId);
            setUserList(result.data);
            let userIdValue = result.data.find(x => x.Name === user.username)?.Id;
            if(userIdValue !== undefined){
                setUserId(userIdValue);
            }

            
        } catch (error) {
            console.log(error)
        }
    }
    const getInvalidPersonList = async(noteId: string) => {
        try {
            let result = await NoteService.GetInvalidUserList(noteId);
            setInvalidUserList(result.data);
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        if(props.id){
            getNote(props.id);
            getInvalidPersonList(props.id);
        }
        getResponsiblePersonList();
        

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if(isLoading){
        return (  <SmallLoading />);
    }
    else{
        return (
            <>
            <Dialog open={props.showNoteModal} onClose={() => handleCancel()} aria-labelledby="form-dialog-title" maxWidth='md' fullWidth>
                <CustomDialogTitle id="customized-dialog-title" onClose={() => handleCancel()}>
                    {props.id ? "Edit Note" : "Add Note"}
                </CustomDialogTitle>
                <DialogContent>
                <Grid container justifyContent='center'>
                    <Grid item xs={12} lg={12}>
                        <form id="noteForm"  onSubmit={handleSubmit(handleDataSubmit)}>
                            <MDBox>
                                <MDBox>
                                    <Grid item xs={12}>
                                        <MDBox mb={2}>
                                            <Grid container >
                                                <Grid item xs={12} sm={4} md={4} lg={4}>
                                                    <MDTypography variant='button' fontWeight='regular' style={{color:'#666666', fontSize:"0.85em"}}>
                                                        User                           
                                                    </MDTypography>
                                                </Grid>
                                                <Grid item xs={12} sm={5} md={4} lg={4}>
                                                    <Controller
                                                        control={control}
                                                        name="Username"
                                                        render={({ field: { value } }) => (
                                                            
                                                            <MDTypography variant='button' fontWeight='regular' style={{color:'#666666', fontSize:"0.85em"}} >
                                                                {props.id? value: user.username}
                                                            </MDTypography>
                                                        )}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </MDBox>
                                        <MDBox mb={2}>
                                            <Grid container >
                                                <Grid item xs={12} sm={4} md={4} lg={4}>
                                                    <MDTypography variant='button' fontWeight='regular' style={{color:'#666666', fontSize:"0.85em"}} >
                                                        Date
                                                    </MDTypography>
                                                </Grid>
                                                <Grid item xs={12} sm={5} md={4} lg={4}>
                                                    <Controller
                                                        control={control}
                                                        name="CreatedDate"
                                                        render={({ field: { value } }) => (
                                                            
                                                            <MDTypography variant='button' fontWeight='regular' style={{color:'#666666', fontSize:"0.85em"}} >
                                                                {props.id? StringDateTimeHelper(value)?.replace(',','') : DateTimeHelper(createdDate)?.replace(',','')}
                                                            </MDTypography>          
                                                        )}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </MDBox>
                                       
                                        <MDBox mt={3} mb={2} className="leftAlign">
                                            <MDTypography variant='button' fontWeight='regular' style={{color:'#666666', fontSize:"0.85em"}}>
                                                Description* (Max 1000 characters)
                                            </MDTypography>
                                            <Controller
                                                control={control}
                                                name="NoteText"
                                                render={({ field: { onChange, value } }) => (
                                                    <Quill
                                                    initialContent={value}
                                                    maxLength={descriptionMaxLength}
                                                    handleChange={(newValue: string) => {
                                                        onChange(newValue);
                                                        setValue('NoteText', newValue);
                                                    }}
                                                    setRemainingCharacters={setRemainingNoteCharacters}
                                                />
                                        )}
                                    />
                                        <MDTypography
                                            variant="button"
                                            fontWeight="regular"
                                            style={{  color:
                                                remainingNoteCharacters < 0
                                               ? "#FF0000" 
                                               : "#666666", 
                                                fontSize: "0.85em"
                                            }}
                                        >
                                            {remainingNoteCharacters} characters remaining
                                        </MDTypography>
                                            {(!!errors.NoteText) && <FormHelperText error>{errors.NoteText?.message}</FormHelperText>}
                                        </MDBox>
                                        {invalidUsers?.length > 0 && <MDBox mb={2}>
                                            <Controller
                                                control={control}
                                                name="InvalidResponsibleUserList"
                                                render={({ field: { onChange, value } }) => (
                                                    <Autocomplete
                                                        multiple
                                                        open={false}  
                                                        forcePopupIcon={false}
                                                        options={invalidUserList}
                                                        getOptionLabel={option => option.Name}
                                                        isOptionEqualToValue={(option, value) => option.Id === value.Id}
                                                        value={invalidUserList.filter((user) => value?.includes(user.Id))}
                                                        autoComplete={false}
                                                        disableClearable={false}
                                                        disabled={!canEdit}
                                                        onChange={(e: any, newValue: any) => {
                                                            if(newValue){
                                                                const list: string[] = [];
                                                                newValue?.forEach((element: any) => {
                                                                    list.push(element.Id)
                                                                });
                                                                onChange(list);
                                                                setValue("InvalidResponsibleUserList", list);
                                                            }
                                                        }}
                                                        renderInput={(params) => 
                                                            <TextField label='Invalid Responsible Person(s)' {...params} type='text'
                                                            variant="standard"
                                                            error={!!errors.InvalidResponsibleUserList}
                                                            helperText={(errors.InvalidResponsibleUserList as any)?.message}
                                                            />
                                                        }
                                                    /> 
                                                )}
                                            />
                                        </MDBox>}
                                        <MDBox mb={2}>
                                            <Controller
                                                control={control}
                                                name="ResponsibleUserList"
                                                render={({ field: { onChange, value } }) => (
                                                    <Autocomplete
                                                        multiple
                                                        options={userList}
                                                        getOptionLabel={option => option.Name}
                                                        isOptionEqualToValue={(option, value) => option.Id === value.Id}
                                                        value={userList.filter((user) => value?.includes(user.Id))}
                                                        disabled={!canEdit}
                                                        onChange={(e: any, newValue: any) => {
                                                            if(newValue){
                                                                const list: string[] = [];
                                                                newValue?.forEach((element: any) => {
                                                                    list.push(element.Id)
                                                                });
                                                                onChange(list);
                                                                setValue("ResponsibleUserList", list);
                                                            }
                                                        }}
                                                        renderOption={(props, option) => {
                                                            return (
                                                                <li {...props} key={option.Id}>
                                                                    {option.Name}
                                                                </li>
                                                            );
                                                        }}
                                                        renderInput={(params) => 
                                                            <TextField label='Responsible Person(s)' {...params} type='text'
                                                            variant="standard"
                                                            error={!!errors.ResponsibleUserList}
                                                            helperText={(errors.ResponsibleUserList as any)?.message}
                                                            />
                                                        }
                                                    /> 
                                                )}
                                            />
                                        </MDBox>
                                        <MDBox mt={4} mb={2}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    <Controller
                                                        control={control}
                                                        name="ActionDate"
                                                        render={({ field: { onChange, value } }) => (
                                                            <ValidatedMobileDatePicker
                                                                inputFormat="yyyy/MM/dd"
                                                                mask="____/__/__"
                                                                label="Action Date"
                                                                value={value}
                                                                disabled={!canEdit}
                                                                onChange={(date: string) => {
                                                                    if (date != null) {
                                                                        onChange(date);
                                                                        setValue("ActionDate", date);
                                                                    }
                                                                }}
                                                                renderInput={(params: any) => <TextField {...params} 
                                                                    error={!!errors.ActionDate}
                                                                    helperText={errors.ActionDate?.message} 
                                                                    />
                                                                }
                                                                views={['year', 'month', 'day']}
                                                            />
                                                        )}
                                                    />
                                            </LocalizationProvider>
                                        </MDBox>
                                        <MDBox>
                                            <Controller
                                                control={control}
                                                name="Status"
                                                render={({ field: { onChange, value } }) => (
                                                    <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={value}
                                                            disabled={!canEdit}
                                                            onChange={(e: any) =>{
                                                                onChange(e.target.checked);
                                                                setValue("Status", e.target.checked);
                                                            }}
                                                            color="secondary"
                                                        />
                                                        }label="Completed"
                                                    />
                                                )}
                                            />
                                        </MDBox>
                                    </Grid>
                                </MDBox>
                            </MDBox>
                        </form>
                        {props.id !== undefined && <MDBox mt={2}>
                            <FeedbackTable noteId={props.id} userId={userId}></FeedbackTable>
                        </MDBox>}
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Box>
                    <LoadingButton variant='contained' color="primary" type='submit' form="noteForm" loading={isSubmitting} disabled={!canEdit}>
                        Save 
                    </LoadingButton>
                </Box>
            </DialogActions>
        </Dialog>
    </>);
    }
}
